import { createContext } from 'react'

// True under a modal, so a drawer opened there stacks above it rather than behind (Bootstrap puts
// offcanvas at z-index 1045, modals at 1055).
const OverModalContext = createContext(false)

export default OverModalContext
